import Button from '@sdk/components/ui/buttons/Button';
import gettext from '@sdk/lang/gettext';

import { FooterRegularButtonWrapper } from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/timesheetViewModalFooter.styles';

type Props = {
  onClose: VoidFunction;
};
const CloseTimesheetFooterButton = ({ onClose }: Props) => (
  <FooterRegularButtonWrapper mLeft={10}>
    <Button onClick={onClose}>{gettext('Close')}</Button>
  </FooterRegularButtonWrapper>
);

export default CloseTimesheetFooterButton;
